import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { TicketService } from 'src/app/Service/Ticket/Ticket.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { environment } from 'src/environments/environment';
import { Ticket_Interface } from 'src/app/Interface/Ticket_Interface';

@Component({
  selector: 'app-TicketReply',
  templateUrl: './TicketReply.component.html',
  styleUrls: ['./TicketReply.component.css']
})
export class TicketReplyComponent implements OnInit {

  @Input() Ticket_Selected:Ticket_Interface
  @Output() OnBack_Ticket_Action = new EventEmitter<number>();

  Token:String=""
  public Editor = ClassicEditor;
  public model = {
    editorData: '<p>Type your text here...</p>'
};
  public config = {
    language: 'fa'
};

  constructor(
    private Alertify_Service:AlertifyService,
    private Ticket_Service:TicketService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
  }



  //#region Image
  BaseUrl=environment.BaseUrl
  UploadImageSrc_List:Array<string>=[]
  UploadImageSrc:string=''
  InProccessing_Image1:boolean=false
  uploadImage1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1=true

    this.Ticket_Service.uploadFile(formData,this.Token).subscribe(
      data=>{
        this.InProccessing_Image1=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.UploadImageSrc=data['filename']
        }
      }
    )

  }

  Remove_uploadImage1(){
    this.UploadImageSrc=''
  }

  Add_uploadImage1(){
    this.UploadImageSrc_List.push(this.UploadImageSrc)
    this.UploadImageSrc=''
    this.Alertify_Service.SuccessMessage("Added to the table.")
  }

  UploadImageSrc_List_Delete(id:number)
      {
        this.UploadImageSrc_List.splice(id,1)
        this.Alertify_Service.SuccessMessage("Deleted successfully.")
      }

    modalRef_Image: any;
    ModalimageUrl:string=''
    openModal(template: TemplateRef<any>,imageUrl:string) {
      this.ModalimageUrl=imageUrl
      this.modalRef_Image = this.modalService.show(template);
    }

//#endregion


  InProccessing:boolean=false
  onSubmitForm(){

    this.InProccessing=true
    this.Ticket_Service.ReplyTicket(this.model.editorData,this.Ticket_Selected.id,this.Token,this.UploadImageSrc_List).subscribe(
      data=>{
        this.model.editorData='<p>Type your text here...</p>'
        this.UploadImageSrc_List=[]
        this.Alertify_Service.SuccessMessage("Information saved successfully.")
        this.InProccessing=false
        this.OnSet_Back_Ticket()
      }
    )

  }

  OnSet_Back_Ticket(){
    this.OnBack_Ticket_Action.emit(-1);
  }


}
